import React from "react";
import { Link } from "react-router-dom";
import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from "../constants/contact";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <h4>IT Assist Experts</h4>
            <p>
              IT Assist Experts offers comprehensive IT assistance services for
              laptops, desktops, printers, and all your technology needs. Our
              expertise spans device maintenance, problem resolution, network
              setup, malware elimination, data recovery, and preventive
              maintenance to keep your devices running smoothly.
            </p>
          </div>
          <div className="col-md-3">
            <h4>Important Links</h4>
            <ul>
              <li>
                <Link to="/aboutus">About Us</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy & Policy</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/contactus">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div className="col-md-3">
            <h4>Contact Details</h4>
            <address>
              <p>
                <i className="bi bi-geo-alt-fill"></i> No6401 31ST ST S APT 112,
                SAINT PETERSBURG, FL 33712 US
              </p>
              <p>
                <i className="bi bi-geo-alt-fill"></i> 2296 Henderson Mill Rd
                #116, Atlanta, GA 30345
              </p>
              <p>
                <i className="bi bi-telephone-fill"></i>{" "}
                <a href={`tel:${SUPPORT_PHONE_TEL}`}>
                  {SUPPORT_PHONE_DISPLAY}
                </a>
              </p>
              <p>
                <i className="bi bi-envelope-fill"></i>{" "}
                support@itassistexperts.com
              </p>
            </address>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
